import { RequestingOrganisationDto } from '@services/RequestingOrganisationsService'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  createOrganisation,
  findAllOrganisations,
  removeOrganisation,
  updateOrganisation,
} from '@state/thunks/organisationThunk'

type OrganisationState = {
  organisations: RequestingOrganisationDto[]
  totalCount: number
}

const initialState: OrganisationState = {
  organisations: [],
  totalCount: 0,
}

const organisationSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      findAllOrganisations.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.organisations = payload?.datas ?? []
        state.totalCount = payload?.totalCount ?? 0
      },
    )
    builder.addCase(
      createOrganisation.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.organisations = [...state.organisations, payload]
      },
    )
    builder.addCase(
      updateOrganisation.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        const index = state.organisations.findIndex((o) => o.id === payload.id)
        if (index !== -1) {
          state.organisations[index] = payload
        }
      },
    )
    builder.addCase(
      removeOrganisation.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.organisations = state.organisations.filter(
          (o) => !payload.ids.includes(o.id),
        )
      },
    )
  },
})

// eslint-disable-next-line no-empty-pattern
export const {} = organisationSlice.actions

export default organisationSlice.reducer
